import { AuthRepository } from '../Repositories/AuthRepository';
import { User } from '../../Model/User';

export class MeUseCase {
  constructor(private repo: AuthRepository) {}
  execute(): Promise<User> { return this.repo.me(); }
}
